import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.PROJECTS,
  displayName: "Projects",
  displayOrder: 3,
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "projects-icon",
    title: "Projects",
    valueTransformer: (value) => Number(value).toLocaleString("en-US"),
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: Number(value).toLocaleString("en-US"),
        units: "Per month",
      };
    },
  },
};

export default entitlement;
